module.exports = "/_next/static/images/227d87fbebe50c68a2b401182d4c5822-xpeers-lg.jpg";